import { useEffect, useState, useRef } from 'react';
import { isEqual, cloneDeep } from 'lodash';

export default function useFlatData(
	getData: any,
	data: {
		data: any;
		totalPages: number | undefined | null;
		page: number | undefined | null;
	},
	page: number,
	setPage: any,
	defaultFilter?: object,
	enabled: boolean = true,
) {
	const [filter, setFilter] = useState(defaultFilter || {});
	const [flatData, setFlatData] = useState<any[]>([]);
	const [hasMoreData, setHasMoreData] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [lastFilter, setLastFilter] = useState<object | undefined>(undefined);

	const timeout: any = useRef();

	useEffect(() => {
		if (!enabled) {
			return;
		}

		loadData();
	}, [page, enabled]);

	useEffect(() => {
		if (!enabled) {
			return;
		}

		if (!isEqual(filter, lastFilter)) {
			setIsLoading(true);
			setLastFilter(cloneDeep(filter));
			loadData(true);
		}
	}, [filter, enabled]);

	useEffect(() => {
		if (!enabled) {
			return;
		}

		setIsLoading(true);

		if (timeout.current) {
			clearTimeout(timeout.current);
		}

		if (data) {
			const gqlData = data?.data;
			const totalPages = data?.totalPages || 0;
			const currentPage = data?.page || 0;

			if (!isNaN(totalPages) && !isNaN(currentPage)) {
				setHasMoreData(totalPages > currentPage);
			}

			timeout.current = setTimeout(() => {
				if (gqlData) {
					if (currentPage && currentPage > 1) {
						setFlatData(prevFlatData => [...prevFlatData, ...gqlData]);
					} else {
						setFlatData(gqlData);
					}
				}

				setIsLoading(false);
			}, 700);
		} else {
			setIsLoading(false);
		}
	}, [data?.data, enabled]);

	const loadData = (reset: boolean = false) => {
		if (!enabled) {
			return;
		}

		if (reset && page !== 1) {
			setPage(1);
			return;
		}

		getData(filter);
	};

	return {
		flatData,
		hasMoreData,
		setFilter,
		loadData,
		isLoading,
	};
}
